module.exports = __webpack_public_path__ + "static/media/data-consolidation.3a267173.jpg";